export const localStorageKeys = {
  loginResponse: "facebookResponse",
  userImg: "userImg",
  appMode: "appMode",
  currentcity: "currentcity",
};
